import type { ProductSummaryMetadata } from 'components/common-form/sidePanel/docToolbar/summary/builder/model';

export type ProductSummaryActions = ProductSummaryReceived | ProductSummaryRequested | ProductSummaryClosed;

///////////////////////////////////////////
export function productSummaryRequested(tabId: string) {
  return {
    type: 'PRODUCT_SUMMARY_REQUESTED' as const,
    tabId,
  };
}

export type ProductSummaryRequested = ReturnType<typeof productSummaryRequested>;

////////////////////////////////////
export function productSummaryReceived(tabId: string, payload: ProductSummaryMetadata) {
  return {
    type: 'PRODUCT_SUMMARY_RECEIVED' as const,
    tabId,
    payload,
  };
}

export type ProductSummaryReceived = ReturnType<typeof productSummaryReceived>;

////////////////////////////////////

export function productSummaryClosed(tabId: string) {
  return {
    type: 'PRODUCT_SUMMARY_CLOSED' as const,
    tabId,
  };
}

export type ProductSummaryClosed = ReturnType<typeof productSummaryClosed>;

////////////////////////////////////
